import React from 'react';
import { useActivities, useStudents } from '@/hooks/useSupabaseData';
import { useStudentImport } from '@/hooks/useStudentImport';
import { ImportTemplateCard } from './import/ImportTemplateCard';
import { FileUploadCard } from './import/FileUploadCard';
import { ImportInstructionsCard } from './import/ImportInstructionsCard';
import { StudentPreviewCard } from './import/StudentPreviewCard';
import { ActivitySelectionCard } from './import/ActivitySelectionCard';
import { ImportResultCard } from './import/ImportResultCard';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

export const BulkStudentImporter = ({ simple = false }: { simple?: boolean }) => {
  const { activities } = useActivities();
  const { students, refetch: refetchStudents } = useStudents();
  
  const {
    importedStudents,
    selectedActivities,
    step,
    fileName,
    importResult,
    isImporting,
    handleFileChange,
    handleActivityToggle,
    handleImport
  } = useStudentImport(students, refetchStudents);

  return (
    <div className="space-y-6 max-h-[80vh] overflow-y-auto">
      {/* Paso 1 y 2: Descarga de plantilla y subida de archivo */}
      <div className="flex flex-col gap-4">
        <ImportTemplateCard />
        <FileUploadCard onFileChange={handleFileChange} fileName={fileName} />
      </div>

      {/* Instrucciones de detección de duplicados */}
      <ImportInstructionsCard />

      {/* Vista previa y (opcionalmente) selección de actividades */}
      {step === 'preview' && (
        <div className="space-y-6">
          <StudentPreviewCard students={importedStudents} />
          {simple ? (
            <Button 
              onClick={handleImport} 
              disabled={importedStudents.length === 0 || isImporting}
              className="w-full md:w-auto"
            >
              {isImporting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Importando...
                </>
              ) : (
                `Importar ${importedStudents.length} alumnos`
              )}
            </Button>
          ) : (
            <ActivitySelectionCard 
              activities={activities}
              selectedActivities={selectedActivities}
              onActivityToggle={handleActivityToggle}
              onImport={handleImport}
              studentsCount={importedStudents.length}
              isImporting={isImporting}
            />
          )}
        </div>
      )}

      {/* Resultados de importación */}
      {importResult && <ImportResultCard result={importResult} />}
    </div>
  );
};